import css from 'styled-jsx/css'
import { colors } from '../../../styles'

export default css`
.PinCheckDialog :global(.Dialog) {
  max-width: 825px;
}

.incorrect-pin-warning {
  color: ${colors.red};
}

form {
  max-width: 300px;
  margin: 3em auto 1.5em;
}

@media (min-width: 480px) {
  form {
    max-width: 360px;
  }
}
`
